import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "isOpen", "disabled", "children"];
import { forwardRef, useMemo } from 'react';
import { bool } from 'prop-types';
import { jsx } from 'react/jsx-runtime';
import { defineName } from '../utils/utils.js';
import { stylePropTypes } from '../utils/propTypes.js';
import { useBEM } from '../hooks/useBEM.js';
import { menuButtonClass } from '../utils/constants.js';
const MenuButton = /*#__PURE__*/defineName('MenuButton', /*#__PURE__*/forwardRef(function MenuButton(_ref, ref) {
  let {
      className,
      isOpen,
      disabled,
      children
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const modifiers = useMemo(() => ({
    open: isOpen
  }), [isOpen]);
  return /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-disabled": disabled || undefined,
    type: "button",
    disabled: disabled
  }, restProps), {}, {
    ref: ref,
    className: useBEM({
      block: menuButtonClass,
      modifiers,
      className
    }),
    children: children
  }));
}));
process.env.NODE_ENV !== "production" ? MenuButton.propTypes = _objectSpread(_objectSpread({}, stylePropTypes()), {}, {
  isOpen: bool,
  disabled: bool
}) : void 0;
export { MenuButton };